import React, { FC } from 'react';

import './DonutChart.scss';

const DonutChart: FC<DonutChartProps> = ({
  className,
  dataPoints,
  chartOptions
}) => {
  const halfsize = chartOptions.size * 0.5;
  const radius = halfsize - chartOptions.strokeWidth * 0.5;
  const circumference = 2 * Math.PI * radius;

  let offset = circumference * chartOptions.offsetRatio;

  return (
    <svg className={className}>
      {dataPoints.map((point, index) => {
        const percentDonut = (point.value / 100) * circumference;
        const dashArray = percentDonut + ' ' + (circumference - percentDonut);
        offset += percentDonut;

        return (
          <circle
            key={index}
            className={`${chartOptions.classNames[index]} fill`}
            r={radius}
            cx={halfsize}
            cy={halfsize}
            strokeWidth={chartOptions.strokeWidth}
            strokeDasharray={dashArray}
            strokeDashoffset={offset}
          />
        );
      })}
    </svg>
  );
};

export default DonutChart;
